import React from 'react';
import s from '../../pages/PDV.module.css';

const fmtBRL = v =>
  Number(v || 0).toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 });

export default function ModalPreVenda({ modalPreVenda, setModalPreVenda, buscandoPrev, pedidosAprov, idxPrev, setIdxPrev, importarPreVenda, devolucoesPend = [], finalizarDevolucaoCaixa }) {
  if (!modalPreVenda) return null;
  return (
        <div className={s.modalOverlay} onClick={() => setModalPreVenda(false)}>
          <div className={s.modalPreVenda} onClick={e => e.stopPropagation()}>
            <div className={s.modalTitleBar}>
              <span>F2 — Pré-venda / Importar Pedido</span>
              <button className={s.modalClose} onClick={() => setModalPreVenda(false)}>✕</button>
            </div>
            <div className={s.f3GridWrap}>
              <table className={s.f3Grid}>
                <thead>
                  <tr>
                    <th style={{width:80}}>Pedido</th>
                    <th>Cliente</th>
                    <th style={{width:120}}>Data</th>
                    <th style={{width:90}} className={s.right}>Total R$</th>
                    <th style={{width:80}}>Status</th>
                  </tr>
                </thead>
                <tbody>
                  {buscandoPrev && <tr><td colSpan={5} className={s.f3Vazio}>Buscando pedidos aprovados…</td></tr>}
                  {!buscandoPrev && pedidosAprov.length === 0 && (
                    <tr><td colSpan={5} className={s.f3Vazio}>Nenhum pedido aprovado encontrado.</td></tr>
                  )}
                  {pedidosAprov.map((p, i) => (
                    <tr key={p.id || i}
                      className={idxPrev === i ? s.f3LinhaSel : ''}
                      onClick={() => setIdxPrev(i)}
                      onDoubleClick={() => importarPreVenda(p)}>
                      <td>{p.numero || p.id}</td>
                      <td>{p.cliente_nome || p.cliente || '—'}</td>
                      <td>{p.data ? new Date(p.data).toLocaleString('pt-BR') : '—'}</td>
                      <td className={s.right}>{fmtBRL(p.total)}</td>
                      <td>{p.status}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
            {devolucoesPend.length > 0 && (
              <div className={s.f3GridWrap} style={{ borderTop: '2px solid #b45309', maxHeight: 180 }}>
                <table className={s.f3Grid}>
                  <thead>
                    <tr>
                      <th colSpan={5} style={{ background: '#fef3c7', color: '#92400e' }}>
                        ↩ Devoluções aguardando finalização no caixa
                      </th>
                    </tr>
                    <tr>
                      <th style={{width:80}}>Dev.</th>
                      <th>Cliente</th>
                      <th style={{width:120}}>Data</th>
                      <th style={{width:90}} className={s.right}>Reembolso R$</th>
                      <th style={{width:110}}></th>
                    </tr>
                  </thead>
                  <tbody>
                    {devolucoesPend.map(d => (
                      <tr key={d.id}>
                        <td>#{d.id} <span style={{color:'#888',fontSize:10}}>(venda {d.venda_id})</span></td>
                        <td>{d.cliente_nome || 'Consumidor'}</td>
                        <td>{d.data_devolucao ? new Date(String(d.data_devolucao).slice(0,10) + 'T12:00').toLocaleDateString('pt-BR') : '—'}</td>
                        <td className={s.right} style={{ color: '#b91c1c', fontWeight: 'bold' }}>{fmtBRL(d.total)}</td>
                        <td>
                          <button className={s.movBtnFiscal}
                            style={{ height: 22, fontSize: 11 }}
                            title="Reembolsa pelo caixa deste turno e permite transmitir a NF-e de devolução"
                            onClick={() => finalizarDevolucaoCaixa(d)}>
                            💸 Finalizar
                          </button>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            )}
            <div className={s.f3Rodape}>
              <span className={s.f3Label}>Duplo clique, Enter ou Ok para abrir pedido no PDV</span>
              <div className={s.f3BotoesRodape}>
                <button className={s.f3BtnOk}
                  disabled={idxPrev === null}
                  onClick={() => idxPrev !== null && importarPreVenda(pedidosAprov[idxPrev])}>Ok</button>
                <button className={s.f3BtnSair} onClick={() => setModalPreVenda(false)}>Sair</button>
              </div>
            </div>
          </div>
        </div>
  );
}
